export const FREE_TIME_SECONDS = 15